import {
  SET_IA_RESPONSE,
  CLEAR_IA_RESPONSE,
  SET_NEW_TRACKING,
  CLEAR_NEW_TRACKING,
} from "Actions/ActionsTypes";

const defaultState = {
  IAReponse: null,
  newTracking: null,
};

export default function IABudget(state = defaultState, action) {
  switch (action.type) {
    case SET_IA_RESPONSE:
      return {
        ...state,
        IAReponse: action.payload,
      };

    case CLEAR_IA_RESPONSE:
      return {
        ...state,
        IAReponse: null,
      };

    case SET_NEW_TRACKING:
      return {
        ...state,
        newTracking: action.payload,
      };

    case CLEAR_NEW_TRACKING:
      return {
        ...state,
        newTracking: null,
      };

    default:
      return state;
  }
}
